//HDI Priority
export const HDI_SG_LEVEL_L0 = 'L0';
export const HDI_SG_LEVEL_L1 = 'L1';
export const HDI_SG_LEVEL_L2 = 'L2';
